export default {
  path: '/quality',
  title: '云跟单',
  icon: 'file-text-o',
  children: [
    {
      path: 'basic',
      title: '基本数据',
      icon: 'database',
      children: [
        {
          path: 'supplier',
          title: '供应商管理',
          component: 'quality/basic/supplier'
        },
        {
          path: 'customer',
          title: '客户管理',
          component: 'quality/basic/customer'
        },
        {
          path: 'defectType',
          title: '疵点类型',
          component: 'quality/basic/defectType'
        },
        {
          path: 'inspectionType',
          title: '验货类型',
          component: 'quality/basic/inspectionType'
        },
        {
          path: 'review',
          title: '审核配置',
          component: 'quality/basic/review'
        }
      ]
    },
    {
      path: 'inspection',
      title: '质检管理',
      icon: 'book',
      children: [
        {
          path: 'basic',
          title: '基础清单',
          tabCache: true,
          component: 'quality/inspection/basic'
        },
        {
          path: 'basicChecklist',
          title: '基础清单维护',
          disableMenu: true,
          disableTab: true,
          disableAuth: true,
          component: 'quality/inspection/basicChecklist'
        },
        {
          path: 'item',
          title: '质检清单',
          tabCache: true,
          component: 'quality/inspection/item'
        },
        {
          path: 'itemChecklist',
          title: '质检清单维护',
          disableMenu: true,
          disableTab: true,
          disableAuth: true,
          component: 'quality/inspection/itemChecklist'
        },
        {
          path: 'process',
          title: '流程配置',
          component: 'quality/inspection/process'
        }
      ]
    },
    {
      path: 'order/list',
      title: '质检任务',
      icon: 'tasks',
      tabCache: true,
      component: 'quality/order/list'
    },
    {
      path: 'order/detail',
      title: '质检报告',
      disableMenu: true,
      disableTab: true,
      disableAuth: true,
      component: 'quality/order/detail/index'
    },
    {
      path: 'order/defect',
      title: '疵点报告',
      disableMenu: true,
      disableTab: true,
      disableAuth: true,
      component: 'quality/order/detail/defect'
    },
    {
      path: 'order/history',
      title: '历史质检报告',
      disableMenu: true,
      disableTab: true,
      disableAuth: true,
      component: 'quality/order/detail/history'
    },
    {
      path: 'statistics',
      title: '统计管理',
      icon: 'pie-chart ',
      children: [
        {
          path: 'inspection',
          title: '验货统计',
          component: 'quality/statistics/inspection'
        },
        {
          path: 'supplier',
          title: '供应商统计',
          component: 'quality/statistics/supplier'
        },
        {
          path: 'inspector',
          title: '质检员统计',
          component: 'quality/statistics/inspector'
        }
      ]
    }
  ]
}
